// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box_07":"box_07-2YctqqiV","clearfix":"clearfix-1rITC43U","box_07_a":"box_07_a-skUIXXJE","bag":"bag-3KMHpO7l","text_02":"text_02-2sSjnsKB"};